//import { HttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SerialNumberSearchResult } from '@ecs-services/search/search.interface';
import { HeaderConfigService, LanguageService } from '@os-components';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ReplaceDoubleLinebreakPipe } from '../../pipes/replace-linebreak.pipe';
import { RhDoc, SafetyHint, SafetyHintResponse } from './safety-hint.interface';

@Injectable({
    providedIn: 'root',
})
export class SafetyHintService {
    private project: string;
    private country: string;
    private replaceDoubleLinebreakPipe = new ReplaceDoubleLinebreakPipe();

    public constructor(
        private http: HttpClient,
        private configService: HeaderConfigService,
        private languageService: LanguageService
    ) {
        this.project = this.configService.getCmsProject();
        this.country = this.configService.getCountryShort();
    }

    public getTranslatedHints(searchResult?: SerialNumberSearchResult): Observable<SafetyHint[]> | null {
        if (!searchResult) {
            return null;
        }

        const isFunctionalSafety = searchResult.isFunctionalSafety;
        const isAtex = searchResult.isAtex;
        if (isFunctionalSafety || isAtex) {
            return this.languageService.onLanguageChange.pipe(
                switchMap((language) => this.fetchHints(searchResult, language))
            );
        }

        return null;
    }

    public fetchHints(searchResult: SerialNumberSearchResult, language: string): Observable<SafetyHint[]> {
        const dialogFilterParams = [];
        if (searchResult.isFunctionalSafety) {
            dialogFilterParams.push("{'fs_id':'ecs_dialog_functional_safety'}");
        }
        if (searchResult.isAtex) {
            dialogFilterParams.push("{'fs_id':'ecs_dialog_atex'}");
        }

        return this.http
            .get<SafetyHintResponse>(
                `/caas/direct/${
                    this.project
                }/ecs-dialogs?filter={'$and':[{'$or':[${dialogFilterParams.join()}]},{'fs_language':'${language.toUpperCase()}'}]}`
            )
            .pipe(
                map((response) =>
                    response._embedded['rh:doc'].map(
                        (hint: RhDoc) =>
                            ({
                                type: hint.type,
                                title: hint.title,
                                content: this.replaceDoubleLinebreakPipe
                                    .transform(hint.content)
                                    .replace('#!SERIAL_NUMBER!#', searchResult.serialNumber)
                                    .replace('#!LANGUAGE!#', language)
                                    .replace('#!COUNTRY!#', this.country),
                            }) as SafetyHint
                    )
                )
            );
    }
}
